export default __webpack_public_path__ + "static/media/endsight-logo-color.bd2aa158.png";